import PropTypes from 'prop-types'
import {Box} from '@mui/material'
import FilterHeader from '../FilterHeader/FilterHeader'
import RadioGroup from '../RadioGroup'

/**
 * RadioFilterControl - FilterHeader + Radio Group Component
 *
 * A composable component that combines FilterHeader with an independent radio group.
 * Perfect for single-choice selections like All/Yes/No or multiple exclusive options.
 * Separates header logic from radio logic for maximum reusability.
 */
const RadioFilterControl = ({
  label = 'Filter',
  description,
  options = [],
  value = null,
  onChange,
  onRemove,
  showRemoveButton = true,
  orientation = 'vertical',
  disabled = false,
  ...rest
}) => {
  return (
    <Box width='100%'>
      <FilterHeader label={label} description={description} onRemove={onRemove} showRemoveButton={showRemoveButton} />
      <RadioGroup
        options={options}
        value={value}
        onChange={onChange}
        orientation={orientation}
        ariaLabel={label}
        name={`radio-${label.toLowerCase().replaceAll(/\s+/g, '-')}`}
        disabled={disabled}
        {...rest}
      />
    </Box>
  )
}

RadioFilterControl.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  showRemoveButton: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  name: PropTypes.string,
  disabled: PropTypes.bool
}

export default RadioFilterControl
